import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'underscore';
import { Button, Glyphicon } from '@bingads-webui-react/primitive';
import { IconColor } from '../constants';

export const IconButtonAction = ({
  className,
  iconName,
  iconColor,
  onClick,
  ...props
}) => (
  <div className={classNames(className, 'callout-action-button')}>
    <Button onClick={onClick} btnStyle="link" {...props}>
      <Glyphicon glyph={`ba-${iconName}`} style={{ color: iconColor || IconColor[iconName] }} />
    </Button>
  </div>
);

IconButtonAction.propTypes = {
  className: PropTypes.string,
  iconName: PropTypes.string.isRequired,
  iconColor: PropTypes.string,
  onClick: PropTypes.func,
};

IconButtonAction.defaultProps = {
  className: null,
  onClick: _.noop,
  iconColor: null,
};
